import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <>
    <footer className="footer bg-2 bg-overlay-black-90">
      <div className="container">
        <div className="col-md-12">
          <div className="social">
            <ul>
              <li><a className="facebook" href="#"><i className="fab fa-facebook-f"></i> facebook</a></li>
              <li><a className="twitter" href="#"><i className="fab fa-twitter"></i> twitter / X</a></li>
              <li><a className="instagram" href="https://www.instagram.com/thekey.qa"><i className="fab fa-instagram"></i> instagram</a></li>
            </ul>
          </div>
        </div>
        <div className="row mt-5">
          <div className="col-lg-4 col-md-4 mb-4 mb-lg-4">
            <Link className="" to="/"><img className="img-fluid" src="images/The-Key-Logo.png" alt="The Valet Parking Service Doha, Qatar." /></Link>
          </div>
          <div className="col-lg-4 col-md-4 mb-4 mb-lg-4">
            <div className="usefull-link widget-link-new">
              <h6 className="text-white widgettitle">Useful Links</h6>
              <ul>
                <li><Link to="/about-us">Who We Are</Link></li>
                <li><Link to="/terms-and-conditions">Terms and Conditions</Link></li>
                <li><Link to="/privacy-policy">Privacy Policy</Link></li>
                <li><Link to="/contact-us">Get in Touch</Link></li>
                {/* <li><Link to="/tracking">Request Car</Link></li> */}
              </ul>
            </div>
          </div>
          <div className="col-lg-4 col-md-4 mb-4 mb-lg-4">
            <div className="news-letter">
              <h6 className="text-white widgettitle">Contact Information</h6>
              <p>We provide you need to run smooth and reliable valet parking services.</p>
            </div>
            <div className="address">
              <ul>
                <li><i className="fa-solid fa-location-dot"></i><span>Office No. 102, Building 35, Al Mirqab Mall, Zone 38, Qatar.</span></li>
                <li><i className="fa fa-phone"></i><span>+974 3377 7441</span></li>
                <li><i className="fa fa-envelope"></i><span>info@valetparking.qa</span></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="copyright copyright-border">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-12">
              <div className="text-lg-start text-center">
                <p style={{ fontSize: '13px', marginBottom: '0px' }}>© Copyrights 2026 The Key Valet Parking Service</p>
              </div>
            </div>
            <div className="col-lg-6 col-md-12">
              {/* <ul className="list-inline text-lg-end text-center">
                <li style={{ fontSize: '13px' }}>Developed by <a href="https://digitalforge.qa">Digital Forge Information Technology </a></li>
              </ul> */}
            </div>
          </div>
        </div>
      </div>
    </footer>
    <div className="car-top">
      <span><img src="images/car.png" alt="" /></span>
    </div>
    </>
  );
}

export default Footer;

